import {
  all, call, put, select,
} from 'redux-saga/effects';

import getAllItem from '@gc-npm/adabyron.catalogue.get-all-item';

import { actions as devicesActions } from '@/reducers/devices';
import {
  normalizeDevices,
  transformPacParamsToUrlfilters,
} from '@/sagas/normalizers/devices';

const contextStore = (state) => state.main.context;
const pacParamsStore = (state) => state?.devices?.pacParams;

export function* getDevices(data) {
  const {
    build = false,
  } = data.data;
  const context = yield select(contextStore);
  const pacParams = yield select(pacParamsStore);
  yield put(devicesActions.setDevicesStatus('LOADING'));

  const category = 'FUSION_AV';

  try {
    const filters = transformPacParamsToUrlfilters({
      ...pacParams,
      cl: null,
    });
    const [allIncludedItems, allAditionalItems] = yield all([
      call(getAllItem, {
        context,
        Urlfilters: filters,
        offerCategory: category,
        build,
      }),
      call(getAllItem, {
        context,
        Urlfilters: filters,
        offerCategory: `${category}_ADDITIONAL`,
        build,
      }),
    ]);

    const normalizedIncludedDevices = normalizeDevices(allIncludedItems, false, category);
    const normalizedAditionalDevices = normalizeDevices(allAditionalItems, true, category);
    yield put(devicesActions.setDevices({
      incluido: normalizedIncludedDevices,
      adicional: normalizedAditionalDevices,
    }));
    yield put(devicesActions.setDevicesStatus('LOADED'));
  } catch (error) {
    yield put(devicesActions.setDevicesStatus('ERROR'));
  }
}
